module.exports = __webpack_public_path__ + "static/img/Team 5.8e089a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hr/Team 5.png
// module id = l/5p
// module chunks = 2